import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhonesaladLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 317 60",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2
	},
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M27.385,2.255c0.423,4.627 -2.661,9.333 -5.769,12.735c-1.5,1.701 -3.217,3.742 -4.995,5.183c-2.939,2.574 -5.141,5.829 -5.116,9.707l0,0.34c0.097,5.784 5.466,8.614 10.849,9.945c2.076,0.513 5.831,1.202 7.777,1.157c1.821,-0.042 5.387,-0.419 8.128,-1.032c4.096,-0.916 9.821,-3.289 14.248,-6.577c1.292,-0.959 1.514,-1.08 1.73,-0.272c1.548,5.795 -3.616,13.291 -7.814,17.056l-1.766,1.576c-0.484,0.669 -0.181,1.44 0.024,2.166l0.387,1.395c0.931,3.334 0.931,3.334 -0.339,4.219c-0.919,0.272 -1.887,-0.034 -2.77,-0.318c0,0 -4.149,-1.486 -5.963,-2.37c-1.004,-0.34 -2.044,-0.057 -3.048,0.136c-1.234,0.242 -4.112,0.408 -4.112,0.408c-7.298,0.278 -14.431,-2.124 -19.873,-6.691c-0.943,-0.76 -2.939,-2.846 -2.939,-2.846c-2.986,-3.384 -4.964,-7.45 -5.733,-11.783c0,0 -0.309,-2.703 -0.29,-3.878c0,0 0,-4.774 1.258,-5.046c0.726,0.159 0.81,1.1 1.004,1.701c0.798,2.359 2.056,4.706 3.991,6.453c0.206,0.204 1.101,1.055 1.101,1.055c1.051,0.939 3.883,2.472 3.883,2.472c0.639,0.309 1.307,0.563 1.996,0.76l-2.117,-2.019c-0.726,-0.794 -2.637,-3.311 -2.975,-3.708c-7.366,-8.607 -6.459,-19.846 1.899,-27.466c2.419,-2.109 15.361,-10.014 17.345,-4.457Z",
			style: {
				fill: "#61d7ba",
				fillRule: "nonzero"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.761,14.049c0.302,3.198 -1.451,6.124 -3.87,8.278c0.689,-0.079 2.782,-0.147 2.782,-0.147c2.963,-0.011 4.838,1.44 5.322,4.23c0.496,6.906 -14.744,10.773 -20.477,11.567c-5.032,0.635 -14.768,0.703 -17.502,-4.423c0.012,-0.748 0.375,-1.1 1.173,-1.179l0.532,0l0.581,0.011l0.605,0.023c5.116,0.102 8.951,-2.143 11.926,-6.056c0.774,-1.021 1.597,-2.189 2.298,-3.255c1.27,-1.905 14.454,-16.477 16.631,-9.05Z",
			style: {
				fill: "#fdb72d",
				fillRule: "nonzero"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.626,1.915c1.573,4.449 -2.371,9.526 -5.479,12.928l-0.532,0.601c-1.5,1.701 -3.217,3.289 -4.995,4.729c-2.939,2.574 -5.141,5.829 -5.116,9.707c0.012,0.941 0.883,3.901 0.883,3.901c-1.645,-2.064 -2.685,-5.353 -2.806,-7.893c-0.121,-4.117 1.875,-8.437 4.306,-11.794c1.123,-1.536 3.027,-3.95 4.306,-5.375c0.254,-0.295 -0.218,0.329 0,0c-2.201,0.953 -4.233,2.869 -5.685,4.65c-2.122,2.454 -3.924,5.662 -4.717,8.732c-0.75,2.948 -0.835,7.076 0.121,9.979c0.284,0.883 0.72,2.32 1.089,3.175c-1.426,-1.365 -2.61,-3.161 -3.508,-4.876l-0.266,-0.476c-5.032,-9.446 -0.665,-21.24 8.684,-26.65c2.709,-1.486 12.18,-5.682 13.716,-1.338Z",
			style: {
				fill: "#088578",
				fillRule: "nonzero"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.614,8.107c2.525,-2.356 7.152,-3.742 9.071,-3.742c1.21,0 3.072,0.306 3.217,1.644c0.169,4.457 -3.701,7.485 -7.293,9.764c-3.266,2.098 -5.963,4.423 -7.777,7.757c-0.982,1.805 -1.17,2.298 -2.141,1.86c-1.33,-0.601 -1.282,-2.914 -1.27,-4.117c0.011,-1.088 0.207,-2.637 0.665,-3.822c0.764,-1.975 3.067,-7.049 5.528,-9.344Z",
			style: {
				fill: "#fe6549",
				fillRule: "nonzero"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.923,28.225c1.892,1.181 0.224,2.403 -0.943,3.583c-0.344,0.348 -1.041,0.953 -1.041,0.953c-6.785,5.375 -18.99,8.732 -26.198,2.155c-0.568,-0.612 -1.064,-1.588 -0.363,-2.291c0.472,-0.261 0.75,-0.249 1.282,-0.227l1.149,0.011c5.044,0.079 9.471,-1.134 14.212,-2.665c9.382,-3.029 9.644,-2.929 11.902,-1.52Z",
			style: {
				fill: "#fe6449",
				fillRule: "nonzero"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.788,23.552c0.992,1.743 -0.278,4.922 -2.298,5.818c-1.907,0.846 -4.209,0.254 -4.475,-2.381c-0.423,-4.185 4.475,-7.473 6.773,-3.436Z",
			style: {
				fill: "#fdb62d",
				fillRule: "nonzero"
			}
		}),
		/* @__PURE__ */ _jsx("g", { transform: "matrix(47.885344,0,0,47.885344,319.360065,51.095515)" }),
		/* @__PURE__ */ _jsxs("text", {
			x: "62.521px",
			y: "51.096px",
			style: {
				fontFamily: "'Helvetica-Bold', 'Helvetica'",
				fontWeight: 700,
				fontSize: "47.885px",
				fill: "url(#_Linear1)"
			},
			children: ["P", /* @__PURE__ */ _jsx("tspan", {
				x: "92.544px 119.879px 147.214px 174.549px 199.265px 229.289px 254.005px 265.394px 290.11px ",
				y: "51.096px 51.096px 51.096px 51.096px 51.096px 51.096px 51.096px 51.096px 51.096px ",
				children: "honeSalad"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "_Linear1",
			x1: 0,
			y1: 0,
			x2: 1,
			y2: 0,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "matrix(4.56,63.12,-63.12,4.56,196.657665,3.019538)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					style: {
						stopColor: "#088578",
						stopOpacity: 1
					}
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .34,
					style: {
						stopColor: "#189081",
						stopOpacity: 1
					}
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .61,
					style: {
						stopColor: "#57bba3",
						stopOpacity: 1
					}
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					style: {
						stopColor: "#57bba3",
						stopOpacity: 1
					}
				})
			]
		}) })
	]
});
export default SvgPhonesaladLogo;
